angular.module('pitch.app')
.directive('satvAutoFocus', [
    function() {
    "use strict";
    return {
        restrict: 'A',
        // scope: {
        //     condition: '=satvAutoFocus'
        // },
        link: function($scope, elem, attr, ctrl) {
            $scope.$watch(function() {
                return $scope.$eval(attr.satvAutoFocus);
            }, function(v) {
                if (v) {
                    elem[0].querySelectorAll('input, button, textarea, a')[attr.focusIndex || 0].focus();
                }
            });

        }
    };
}])
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/focus.js